import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ActionButton } from '../ui/ConvivialComponents';
import TopAppBar from '../layout/TopAppBar';
import BottomNavigationBar from '../layout/BottomBar';
import { isConvivialNativeAppWebView } from '../../services/nativeAppBridge';

export default function WelcomePage() {
    const navigate = useNavigate();

    // if embedded in webviewggl it doesn't need to load the main screen complete with video
    const isNativeApp = isConvivialNativeAppWebView();

    if (isNativeApp) {
        return (
            <Box
                sx={{
                    minHeight: '100dvh',
                    bgcolor: '#000',
                }}
            />
        );
    }

    return (
        <Box sx={{ minHeight: '100dvh', position: 'relative', overflow: 'hidden', bgcolor: '#000' }}>
            <Box
                component="video"
                autoPlay
                muted
                loop
                playsInline
                src={`${process.env.REACT_APP_BASE_PATH || ''}/assets/background-login.mp4`}
                sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'rgba(0,0,0,0.46)' }} />
            <TopAppBar title="ConvivialApp.it" showAvatar={false} sticky />
            <Stack
                spacing={3}
                sx={{
                    position: 'relative',
                    zIndex: 2,
                    minHeight: 'calc(100dvh - var(--cv-bottom-nav-height))',
                    justifyContent: 'flex-end',
                    px: 3,
                    pb: 'calc(var(--cv-bottom-nav-height) + 28px)',
                    maxWidth: 720,
                    mx: 'auto',
                    color: '#fff',
                    textAlign: 'center',
                }}
            >
                <Box>
                    <Typography variant="h1" sx={{ color: '#fff', fontSize: { xs: 42, md: 56 }, lineHeight: { xs: '50px', md: '64px' } }}>
                        Tutte le grandi cose accadono attorno a un tavolo
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.82)', mt: 2 }}>
                        Trova incontri conviviali, scopri persone interessanti e costruisci relazioni davanti a un buon pasto.
                    </Typography>
                </Box>
                <Stack spacing={1.5}>
                    <ActionButton onClick={() => navigate('/index')}>Trova un tavolo</ActionButton>
                    <ActionButton variant="quiet" onClick={() => navigate('/more-info')}>Come funziona</ActionButton>
                    <ActionButton variant="secondary" onClick={() => navigate('/login')} sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.72)' }}>Accedi</ActionButton>
                </Stack>
            </Stack>
            <BottomNavigationBar valueToHighlight={0} />
        </Box>
    );
}